import { Table, TextField, theme } from '@rario/shared-components'
import { useMemo } from 'react'
import { Document } from '@contentful/rich-text-types'
import { ContentWrapper } from './StaticPageContentStyles'

const StaticPageContent: React.FunctionComponent<{
  htmlContent: string
  pageContent: Document
}> = ({ htmlContent, pageContent }) => {
  const entries = useMemo(() => {
    return pageContent.content.filter(({ nodeType }) => {
      return nodeType === 'embedded-entry-block'
    })
  }, [pageContent])

  const Entries = useMemo(() => {
    return entries.map(
      (
        {
          data: {
            target: { fields },
          },
        },
        i
      ) => {
        if (!fields) {
          return null
        }
        const { tableData, title } = fields
        if (!tableData) {
          return null
        }
        return <Table key={i} title={title} tableData={tableData.tableData} />
      }
    )
  }, [entries])
  return (
    <ContentWrapper>
      <TextField
        fontFamily={theme.fonts.secondary}
        fontSize={'14px'}
        fontWeight="400"
        lineHeight={'28px'}
        as="div"
        html={htmlContent}
      />
      {Entries}
    </ContentWrapper>
  )
}
export default StaticPageContent
